module.exports = __webpack_public_path__ + "images/f0ec424718b688509be6ca5f0f99b6f2-IMG_5274.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/home/IMG_5274.jpg
// module id = ./src/assets/images/slides/home/IMG_5274.jpg
// module chunks = 0